import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb, Table} from 'semantic-ui-react';
import {Helmet} from "react-helmet";


import CustomDivider from '../../components/extras/CustomDivider';
import TableProduct from '../../components/charts/TableProduct';
import FilterBar from '../../components/reports/FilterBar';
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class ProductSales extends Component {

    loadData = (branch_office, date) => {
        if(!localDB.checkPlanAccessExclude('reports_view_all')){
            this.refs.products_day_chart.loadData(branch_office, 'd', date);
            this.refs.products_week_chart.loadData(branch_office, 'w', date);
            this.refs.products_month_chart.loadData(branch_office, 'm', date);
            this.refs.products_year_chart.loadData(branch_office, 'y', date);
        }else {
            this.refs.alert_upgrade.open();
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Venta de Productos - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Venta de Productos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!localDB.checkPlanAccessExclude('ticket_service') ? <Table>
                    <FilterBar title='Productos' callbackGetFilter={this.loadData}/>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={8}>
                                <TableProduct
                                    title='Venta de Productos por Día'
                                    id='products_day_chart'
                                    ref='products_day_chart'
                                />
                            </Table.Cell>
                            <Table.Cell width={8}>
                                <TableProduct
                                    title='Venta de Productos por Semana'
                                    id='products_week_chart'
                                    ref='products_week_chart'
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell width={8}>
                                <TableProduct
                                    title='Venta de Productos por Mes'
                                    id='products_month_chart'
                                    ref='products_month_chart'
                                />
                            </Table.Cell>
                            <Table.Cell width={8}>
                                <TableProduct
                                    title='Venta de Productos por Año'
                                    id='products_year_chart'
                                    ref='products_year_chart'
                                />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>:<UpgradeAccount/>}
                <AlertUpgrade ref='alert_upgrade' />
            </div>
        );
    }
}

export default ProductSales;



// WEBPACK FOOTER //
// ./src/containers/reports/ProductSales.js